import { Link } from "react-router-dom";

export default function NotFound() {
    return <div>
        <h1>Erreur 404 - La page demandée n'existe pas!</h1>
        <Link to="/">Retourner à la page principale</Link>
        </div>;
}